export default __webpack_public_path__ + "static/media/sparkles_green.911fad5c.svg";